import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ClipboardService } from 'ngx-clipboard';
@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent implements OnInit {

    currentId='home';
    gitRepoUrl='git clone https://github.com/rajotron/pgHENCHMAN-Server.git';
    getIntoDir='cd pgHENCHMAN-Server'
    installNpm='npm install'
    runCompilation="npm run predev"
    scriptPerm = 'chmod +x run.sh'
    runscript='./run.sh'
   constructor(private router: Router,private _clipboardService: ClipboardService)  {

    } 
     public loadDynmicallyScript() {
        var script = document.createElement('script');
        script.src = "../assets/js/modernizr.custom.25376.js";
        script.async =false;
        document.head.appendChild(script);
        script.onload = () => console.log("");

         var script2 = document.createElement('script');
        script2.src = "../assets/js/classie.js";
        script2.async =false;
        document.head.appendChild(script2);
        script2.onload = () => console.log("");

                 var script1 = document.createElement('script');
        script1.src = "../assets/js/menu.js";
        script1.async =false;
        document.head.appendChild(script1);
        script1.onload = () => console.log("script loaded");
     }
  ngOnInit(){
  	this.loadDynmicallyScript()
  }
  changeContent(divId){
    this.currentId = divId;

  }
  enter(){
  	this.router.navigateByUrl('/dashboard');
  }
  copy(text: string){
  this._clipboardService.copyFromContent(text)
}

}
